module.exports = __webpack_public_path__ + "static/media/r19.0e200ada.png";